<div
  *ngIf="showClinicFilter || showClinicChainFilter"
  class="l-flex l-flex-wrap t-panel l-align-y t-row--med"
>
  <!--clinic-->
  <input-wrap *ngIf="showClinicFilter" [loading]="clinicList?.loading">
    <p-select
      [options]="clinicList"
      [(ngModel)]="selectedClinic"
      [filter]="true"
      [resetFilterOnHide]="true"
      filterBy="label,id"
      [placeholder]="'translate.general.clinic' | translate"
      [optionLabel]="'label'"
      [filterPlaceholder]="'translate.general.search' | translate"
      (onChange)="onClinicValueChanged()"
      [virtualScroll]="true"
      [virtualScrollItemSize]="30"
      [appendTo]="'body'"
    ></p-select>
    <clear-multi
      *ngIf="selectedClinic"
      (click)="selectedClinic = null; onClinicValueChanged()"
    ></clear-multi>
  </input-wrap>

  <!--clinic chain-->
  <input-wrap
    *ngIf="showClinicChainFilter"
    [loading]="clinicChainList?.loading"
  >
    <p-select
      [options]="clinicChainList"
      [(ngModel)]="selectedClinicChain"
      [filter]="true"
      [resetFilterOnHide]="true"
      filterBy="label,id"
      [placeholder]="'translate.general.clinicChain' | translate"
      [optionLabel]="'label'"
      [filterPlaceholder]="'translate.general.search' | translate"
      (onChange)="onChainValueChanged()"
      [appendTo]="'body'"
    ></p-select>
    <clear-multi
      *ngIf="selectedClinicChain"
      (click)="selectedClinicChain = null; onChainValueChanged()"
    ></clear-multi>
  </input-wrap>
</div>

<lab-kpi
  *ngIf="filterType && !loading"
  #labKpi
  [tag]="'_clinics'"
  [filter]="filter"
  [filterType]="filterType"
></lab-kpi>
